import * as Yup from "yup";

export const farmerValidationSchema = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Minimum 3 characters"),

  mobile: Yup.string()
    .matches(/^\d{10}$/, "Enter valid 10-digit mobile number")
    .required("Mobile number is required"),

  whatsappNo: Yup.string()
    .required("WhatsApp number is required")
    .matches(/^\d{10}$/, "Enter valid 10-digit WhatsApp number"),

  districtName: Yup.string().required("District is required"),
  districtId: Yup.string().optional(),
  mandalName: Yup.string().required("Mandal is required"),
  mandalId: Yup.string().optional(),
  villageName: Yup.string().required("Village is required"),
  villageId: Yup.string().optional(),

  geoCode: Yup.string().optional(),

  totalAcres: Yup.number()
    .typeError("Enter valid acres")
    .positive("Must be positive")
    .optional(),

  acresUnderIrrigation: Yup.string().optional(),

  irrigationType: Yup.string()
    .oneOf(["rainfed", "irrigation"], "Select rainfed or irrigation")
    .required("Irrigation type is required"),

  existingUser: Yup.boolean()
    .required("Existing user is required"),

  majorCrops: Yup.array()
    .of(Yup.string().min(2, "Crop name too short"))
    .min(1, "Select at least one crop")
    .required("Major crops are required"),

  focusCrop: Yup.string().required("Focus crop is required"),

  avatar: Yup.string().optional()
});
